<template>
  <div class="flex gap-x-2">
    <input v-for="(digit, index) in pinCode" :key="index" :ref="(el) => setInputRef(el, index)" v-model="pinCode[index]"
      @input="handleInput(index, $event)" @keydown="handleKeydown(index, $event)" @paste="handlePaste" maxlength="1"
      type="text" inputmode="numeric"
      class="border-2 border-[#F1F4F9] focus:border-primary/50 outline-none focus:ring-0 focus:shadow-none md:w-[62px] md:h-[73px] rounded-xl !font-bold !text-center !text-2xl md:!text-[38px] !text-primary"
      :class="customClasses" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const emit = defineEmits(["sendConfirmCode"]);
const props = defineProps<{
  customClasses?: string;
}>();
const pinCode = ref<string[]>(["", "", "", "", "", ""]);
const inputRefs = ref<(HTMLInputElement | null)[]>([]);

const setInputRef = (el: any, index: number) => {
  if (el) {
    inputRefs.value[index] = el as HTMLInputElement;
  }
};

const handleInput = (index: number, event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (value && !/^\d$/.test(value)) {
    pinCode.value[index] = "";
    return;
  }

  if (value.length > 1) {
    pinCode.value[index] = value.slice(-1);
  }
  if (value && index < 5) {
    inputRefs.value[index + 1]?.focus();
  }
};

const handleKeydown = (index: number, event: KeyboardEvent) => {
  if (event.key === "Backspace" && !pinCode.value[index] && index > 0) {
    inputRefs.value[index - 1]?.focus();
  }
};

const handlePaste = (event: ClipboardEvent) => {
  event.preventDefault();
  const pastedData = event.clipboardData?.getData("text") || "";
  const digits = pastedData.replace(/\D/g, "").slice(0, 6);

  digits.split("").forEach((digit, index) => {
    if (index < 6) {
      pinCode.value[index] = digit;
    }
  });

  const nextEmptyIndex = pinCode.value.findIndex((val) => !val);
  const focusIndex = nextEmptyIndex === -1 ? 5 : Math.min(nextEmptyIndex, 5);
  inputRefs.value[focusIndex]?.focus();
};

watch(
  pinCode,
  (newValue) => {
    const code = newValue.join("");
    if (code.length === 6 && /^\d{6}$/.test(code)) {
      emit("sendConfirmCode", code);
    }
  },
  { deep: true }
);

const clearPinCode = () => {
  pinCode.value = ["", "", "", "", "", ""];
  inputRefs.value[0]?.focus();
};

defineExpose({
  clearPinCode,
});
</script>
